import { AxiosResponse } from 'axios'

const ratesApi = http => ({
  update(rateSetId, rates) {
    return http({
      method: 'put',
      url: `/rate-sets/${rateSetId}/rates`,
      data: rates
    })
  },

  saveRateNotes(rateId, notes) {
    return http({
      method: 'put',
      url: `/rates/${rateId}/notes`,
      data: { notes }
    })
  }
})

export interface RatesHttpModel {
  update: (rateSetId: number, rates: []) => Promise<AxiosResponse>
  saveRateNotes: (rateId: string, notes: string) => Promise<AxiosResponse>
}

export default ratesApi
